import React from 'react';
import { ChatScreen } from '../shared/ChatScreen';

interface TherapistChatScreenProps {
  onBack?: () => void;
}

export const TherapistChatScreen = ({ onBack }: TherapistChatScreenProps = {}) => {
  return <ChatScreen userRole="THERAPIST" onBack={onBack} />;
};
